import { Loading } from "components/ui/Loading/Loading";
/**
 * 招待管理ページ
 */

import type {
  CreateInvitationInput,
  Invitation,
} from "hooks/useInvitationsApi";
import type { FC } from "react";
import { InvitationForm } from "routes/settings/InvitationsPage/InvitationForm";
import { InvitationTable } from "routes/settings/InvitationsPage/InvitationTable";

type InvitationsPageProps = {
  invitations: Invitation[];
  loading: boolean;
  error: { message: string } | null;
  onCreateInvitation: (input: CreateInvitationInput) => Promise<Invitation>;
  onCancelInvitation: (invitationId: string) => Promise<void>;
  isCreating: boolean;
  isCancelling: boolean;
  hasCrmLicense?: boolean;
};

export const InvitationsPage: FC<InvitationsPageProps> = ({
  invitations,
  loading,
  error,
  onCreateInvitation,
  onCancelInvitation,
  isCreating,
  isCancelling,
  hasCrmLicense = false,
}) => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">メンバー招待</h1>
        <p className="text-base-content/60 mt-1">
          新しいメンバーをテナントに招待できます
        </p>
      </div>

      <InvitationForm
        onSubmit={onCreateInvitation}
        isSubmitting={isCreating}
        hasCrmLicense={hasCrmLicense}
      />

      {loading ? (
        <div className="flex justify-center py-8">
          <Loading size="lg" />
        </div>
      ) : error ? (
        <div className="alert alert-error">
          <span>{error.message}</span>
        </div>
      ) : (
        <InvitationTable
          invitations={invitations}
          onCancel={onCancelInvitation}
          isCancelling={isCancelling}
        />
      )}
    </div>
  );
};
